import { createContext, useContext, type ReactNode } from 'react';

/**
 * The current agent id for content rendered inside a `MarkdownContent`.
 *
 * Scanner components (e.g. the filesystem file-path popover) need the agent
 * id to fetch agent-scoped data, but `MarkdownContent` is rendered far from
 * any agent route. Rather than thread the id through every markdown call
 * site, surfaces that own an agent (the SDK chat view, agent stream bubbles)
 * provide it once via this context. When absent, scanner components degrade
 * gracefully (the file popover falls back to the window-event side-tab flow).
 */
const MarkdownAgentIdContext = createContext<string | undefined>(undefined);

export function MarkdownAgentIdProvider({
  agentId,
  children,
}: {
  agentId: string | undefined;
  children: ReactNode;
}) {
  return (
    <MarkdownAgentIdContext.Provider value={agentId}>{children}</MarkdownAgentIdContext.Provider>
  );
}

/** Current agent id for the surrounding markdown, or `undefined` when unknown. */
export function useMarkdownAgentId(): string | undefined {
  return useContext(MarkdownAgentIdContext);
}
